<template>
  <!-- 头部整体盒子 -->
    <div id="header" class="container-fuild">
      <!-- 电脑导航 -->
      <div class="header-nav container hidden-xs">
        <!-- 导航logo -->
        <div class="header-nav-logo" style="color: #fff; width: 20%;float: left;">
          <!-- <img src="@/assets/img/logonew.png"> -->
          <img src="@/assets/img/logo.png" style="max-height: 120px;">
        </div>
        <!-- 导航内容 -->
        <div style="margin-left: 400px;">
          <ul class="header-nav-wrapper" style="width: 70%;margin-left: 100px">
            <li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active aCol':'otherCol'" ref="activeLi"
                @click="navClick(index,item)">
              <a :class="index == navIndex?'aCol':'otherCol'" ref="activeCol">
                {{item.oname}}
                <!--              <i class="underline"></i>-->
              </a>
              <!--            <dl v-if="item.children.length>0">-->
              <!--              <dt v-for="(i,n) in item.children" :key="n">-->
              <!--                <a @click.stop="nav(i)">{{i.oname}}</a>-->
              <!--              </dt>-->
              <!--            </dl>-->
            </li>
          </ul>
        </div>
      </div>
      <!-- 手机导航 -->
      <div class="header-nav-m container-fuild visible-xs">
        <!-- <div class="header-nav-m-logo">
          <img class="center-block" src="@/assets/img/logo_black.png" alt="logo">
        </div> -->
        <!-- 导航栏 -->
        <div class="header-nav-m-menu" style="padding-left: 20px;"  @click="menuClick" data-target="#menu" data-toggle="collapse">
          楚天装饰工程
          <div class="header-nav-m-menu-wrapper text-center"  >
            <span :class="menuClass"></span>
          </div>
          <ul id="menu" class="header-nav-m-wrapper collapse" style="background-color: #FFF">
            <li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''"
                @click="navClick(index,item)" data-toggle="collapse" data-target="#menu" style="background-color: #FFF">
              <a>
                {{item.oname}}
                <!-- <i class="underline"></i> -->
              </a>
            </li>
            <li class="header-tel" style="display: flex;border-bottom: none;margin-top: 10px;">
              <img src="https://tv.w5258.com/website/Picture/banner/phone.png" alt="" />
              <span style="color: #000;margin-left: 20px;">{{companyPhone}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
</template>
<script>
  import {
    appone,
    apptwo
  } from '@/api/category'
  import config from '@/config'
  import {selectusetbyflag} from '@/api/index'
  export default {
    name: "Header",
    data() {
      return {
        companyPhone:'',
        config: config,
        navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
        menuName: "首页",
        menuClass: "glyphicon glyphicon-menu-hamburger",
        navList: [{
            name: "首页",
            path: "home",
            children: []
          },
        ]
      };
    },
    mounted() {
      this.search()
      selectusetbyflag('phone').then(res => {
        if (res.code === 200) {
          this.companyPhone = res.msg
        }
      })
    },
    methods: {
      navClick(index, item) {
        this.navIndex = index;
        sessionStorage.setItem('navIndex', index)
        this.menuName = name;
        if (item.oname != '首页') {
          this.$router.push({
            name: item.tzurl,
          })
        } else {
          this.$router.push('/home')
        }
      },
      nav(item) {
        this.$router.push({
          name: item.tzurl,
        })
      },
      menuClick() {
        if (this.menuClass == "glyphicon glyphicon-menu-down") {
          this.menuClass = "glyphicon glyphicon-menu-hamburger";
        } else {
          this.menuClass = "glyphicon glyphicon-menu-hamburger";
        }
      },
      search() {
        appone().then(res => {
          let one = {
            oname: '首页',
            zxid: 0,
            children: []
          }
          this.navList = res.data
          this.navList.forEach(item => {
            item.children = []
            apptwo({
              parid: item.zxid
            }).then(response => {
              if(response.data) {
                item.children = response.data
              }
            })
          })
          this.navList.unshift(one)
        })
      }
    }
  };
</script>
<style scoped>
  /* 顶部 */
  #header {
    /* background: #f4f4f4; */
    background: rgba(255, 255, 255, 0.88);
    transition: all ease 0.6s;
    /*position: fixed;*/
    top: 0;
    left: 0;
    width: 100%;
    /* background-color: white;*/
   /* z-index: 1000; *//* 确保header在其他内容之上 */
  }
  #header .header-top {
    height: 50px;
    color: #fff;
    font-size: 12px;
    line-height: 50px;
    background-color: rgba(0, 0, 0, 0.88);
  }

  /* 顶部的图标 */
  #header .header-top span {
    margin: 0 8px;
  }

  /* 导航栏 */
  #header .header-nav {
    height: 120px;
  }

  /* 导航栏logo */
  #header .header-nav .header-nav-logo {
    /* width: 100px; */
    /* height: 100%; */
    float: left;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav .header-nav-logo img {
    /* width: 95px;
  height: 45px;
  position: absolute; */
    /* top: 0;
  left: 0;
  right: 0;
  bottom: 0; */
    margin: auto;
    height: 100%;
  }

  /* 导航栏 导航容器 */
  /* #header .header-nav-fixed .header-nav-wrapper {
    line-height: 50px;
  } */

  #header .header-nav .header-nav-wrapper {
    line-height: 120px;
    margin: 0;
    margin-left: 60px;
    display: flex;
    justify-content: space-between;

  }

  /* 导航栏 每个导航 */
  #header .header-nav .header-nav-wrapper>li {
    /* float: left; */
    /* padding: 0 15px; */
    height: 120px;
    position: relative;
    width: 72px;
    text-align: center;
  }
  .active{
    background-color: #ac1212;
    color: #FFF;
  }
  a{
    color: #000;
  }
  .aCol{
    color: #fff;
  }
  .otherCol{
    color: #000;
  }

  /* 导航栏 每个导航 */
  #header .header-nav .header-nav-wrapper>li:hover {
    /* float: left; */
    /* padding: 0 15px; */
    color: #fff;
    background-color: #ac1212;
    a{
      color: #FFFFFF;
    }

  }

  #header .hidden-xs .header-nav-wrapper>li {
    /* float: left; */
    padding: 0 15px;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav .header-nav-wrapper>li>a {
    font-size: 16px;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的下划线 */
  #header .header-nav .header-nav-wrapper>li>a>i {
    display: block;
    position: absolute;
    bottom: -2px;
    left: 50%;
    width: 0;
    height: 2px;
    opacity: 0;
    transition: all 0.6s ease;
    /*background-color: #FF3D00;*/
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 12px;
    transition: transform ease 0.5s;
  }

  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
  /*#header .header-nav .header-nav-wrapper>li>a:hover {
    color: #FFFFFF;
    background-color: red;
    text-decoration: none;
  }
*/
  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
  #header .header-nav .header-nav-wrapper>li>a:hover .underline {
    opacity: 1;
    width: 100%;
    left: 0;
  }

  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
  #header .header-nav .header-nav-wrapper>li>a:hover span {
    transform: rotate(180deg);
  }

  /* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
  /* #header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
} */
  /* 导航栏 每个导航下面的二级导航容器 */
  #header .header-nav .header-nav-wrapper>li>dl {
    display: none;
    position: absolute;
    /* width: 168px; */
    width: 100%;
    text-align: center;
    top: 80%;
    left: 0;
    z-index: 999999;
    /* box-shadow: 0 0 3px 1px #ccc; */
    background: rgb(0, 0, 0);
  }

  /* 导航栏 每个导航下面的二级导航容器的每个导航 */
  #header .header-nav .header-nav-wrapper>li>dl>dt {
    width: 100%;
    padding: 10px 0;
    border-bottom: 1px solid #333333;
  }

  #header .header-nav .header-nav-wrapper>li>dl>dt>a {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.8);
  }

  /* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
  #header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
    text-decoration: none;
    color: #FF3D00;
  }

  /* 导航栏 滑上一级导航显示二级导航 */
  #header .header-nav .header-nav-wrapper>li:hover dl {
    display: block;
  }

  #header .header-nav .header-nav-wrapper>li>dl>dt:hover {
    cursor: pointer;
    /* background: #ccc; */
  }

  @media screen and (max-width: 997px) {
    #header .header-nav-m {
      position: relative;
    }

    /* 导航栏logo容器 */
    #header .header-nav-m .header-nav-m-logo {
      height: 80px;
      position: relative;
    }

    /* 导航栏logo图片 */
    #header .header-nav-m .header-nav-m-logo img {
      width: 95px;
      height: 45px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }

    /* 导航栏  菜单容器 */
    #header .header-nav-m .header-nav-m-menu {
      color: #fff;
      height: 60px;
      font-size: 20px;
      line-height: 60px;
      background-color: rgba(0, 0, 0, 0.88);
      position: relative;
    }

    /* 导航栏 菜单图标 */
    #header .header-nav-m .header-nav-m-menu-wrapper {
      position: absolute;
      top: 50%;
      right: 20px;
      margin-top: -25px;
      width: 50px;
      height: 40px;
      color: #fff;
      z-index: 999999;
      font-size: 12px;
    }

    /* 导航栏 */
    #header .header-nav-m .header-nav-m-wrapper {
      position: absolute;
      top: 50px;
      left: 0;
      width: 100%;
      /* background-color: rgba(0, 0, 0, 0.88); */
      z-index: 9999999;
      background-color: #fff;
      padding: 20px 40px;
    }

    /* 导航栏 每个导航 */
    #header .header-nav-m .header-nav-m-wrapper>li {
      /* height: 40px; */
      line-height: 40px;
      border-bottom: 1px solid #eee;
    }

    #header .visible-xs .header-nav-m-wrapper>li {
      text-align: left;
      padding: 12px 0;
    }

    #header .visible-xs .header-nav-m-wrapper>li>a {
      color: #212121 !important;
      font-weight: normal !important;
    }

    /* 导航栏 每个导航下面的 a 链接 */
    #header .header-nav-m .header-nav-m-wrapper>li>a {
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      padding: 5px 0;
      position: relative;
    }

    /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
    #header .header-nav .header-nav-wrapper>li>a>span {
      font-size: 10px;
    }
  }

  @media (min-width: 1200px) {
    .container {
      width: 1300px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue